import { motion } from 'framer-motion';
import { FaLinkedin } from "react-icons/fa6"
import { CiSaveDown1 } from "react-icons/ci";

export default function Curriculum({t}) {

    const styledText = 'text-persian font-sans font-light text-xl tracking-wide leading-8'
    const handleDownload = () => {
        const link = document.createElement('a')
        link.href = '/profile.pdf' // La ruta del archivo en la carpeta public
        link.download = 'juanbautistacalvoCV.pdf' // El nombre que quieres para el archivo descargado
        link.click()
      }


    return (
        <div className="w-full h-full mt-6">
            <header className="w-full h-full flex justify-end p-6">
                <motion.button
                onClick={handleDownload}
                >
                   <FaLinkedin className="inline" /> <CiSaveDown1 className="inline" /> {t('curriculum.dowload')} 
                </motion.button>
            </header>
            <section className="w-full h-full px-6 space-y-4">
                <p className={styledText}>
                    {t('curriculum.description1')}
                </p>
                <p  className={styledText}>
                    {t('curriculum.description2')}
                </p>
            </section>
        </div>
    )
}